import { IOrderDiscountInfo } from './order-discount-info.model';
import { OrderResponse } from './api-responses';
import { UserOrderStatus } from './user-order.model';

export interface IResultSendingOrder {
  orderInfo: OrderResponse;
  warnings: IWarnings[];
}

export interface IWarnings {
  code: number;
  message: string;
}

export interface OrderMetaData {
  paymentLink: string | null;
  paymentStatus: PaymentStatus | null;
  orderDiscountInfo: IOrderDiscountInfo | null;
}

export enum PaymentStatus {
  Awaiting = 'Awaiting',
  Paid = 'Paid',
  Error = 'Error'
}

// @see OrderStatus.cs
export enum OrderStatus {
  Error = 'Error',
  Draft = 'Draft',
  Canceled = 'Canceled',
  Created = 'Created',
  PaymentAwait = 'PaymentAwait',
  Accepted = 'Accepted',
  Cooking = 'Cooking',
  ReadyToShip = 'ReadyToShip',
  Shipped = 'Shipped',
  Delivered = 'Delivered',
  Closed = 'Closed'
}

export const orderStatuses: { [key in OrderStatus]: UserOrderStatus } = {
  [OrderStatus.Error]: {
    id: 0,
    name: 'Error',
    statusName: OrderStatus.Error,
    languageName: 'ERROR',
    prev: [],
    next: [],
    image: 'assets/img/order-status-cancelled.svg'
  },
  [OrderStatus.Draft]: {
    id: 1,
    name: 'Ожидает подтверждения',
    statusName: OrderStatus.Draft,
    languageName: 'DRAFT',
    next: [
      OrderStatus.Created, OrderStatus.Accepted,
      OrderStatus.PaymentAwait, OrderStatus.Cooking,
      OrderStatus.ReadyToShip, OrderStatus.Shipped,
      OrderStatus.Delivered, OrderStatus.Closed
    ],
    prev: [OrderStatus.Draft],
    image: 'assets/img/order-status-accepted.svg',
  },
  [OrderStatus.Canceled]: {
    id: 2,
    name: 'Canceled',
    statusName: OrderStatus.Canceled,
    languageName: 'CANCELLED',
    next: [],
    prev: [],
    image: 'assets/img/order-status-cancelled.svg'
  },
  [OrderStatus.Created]: {
    id: 3,
    name: 'Created',
    statusName: OrderStatus.Created,
    languageName: 'CREATED',
    next: [
      OrderStatus.Accepted,
      OrderStatus.PaymentAwait, OrderStatus.Cooking,
      OrderStatus.ReadyToShip, OrderStatus.Shipped,
      OrderStatus.Delivered, OrderStatus.Closed
    ],
    prev: [OrderStatus.Draft],
    image: 'assets/img/order-status-accepted.svg'
  },
  [OrderStatus.PaymentAwait]: {
    id: 31,
    name: 'PaymentAwait',
    statusName: OrderStatus.PaymentAwait,
    languageName: 'PAYMENT_AWAIT',
    next: [
      OrderStatus.Cooking,
      OrderStatus.ReadyToShip, OrderStatus.Shipped,
      OrderStatus.Delivered, OrderStatus.Closed
    ],
    prev: [
      OrderStatus.Draft
    ],
    image: 'assets/img/order-status-accepted.svg'
  },
  [OrderStatus.Accepted]: {
    id: 4,
    name: 'Принят',
    statusName: OrderStatus.Accepted,
    languageName: 'ACCEPTED',
    next: [
      OrderStatus.Cooking,
      OrderStatus.ReadyToShip, OrderStatus.Shipped,
      OrderStatus.Delivered, OrderStatus.Closed
    ],
    prev: [
      OrderStatus.Draft, OrderStatus.PaymentAwait
    ],
    image: 'assets/img/order-status-accepted.svg'
  },
  [OrderStatus.Cooking]: {
    id: 5,
    name: 'Готовится',
    statusName: OrderStatus.Cooking,
    languageName: 'COOKING',
    next: [
      OrderStatus.ReadyToShip, OrderStatus.Shipped,
      OrderStatus.Delivered, OrderStatus.Closed
    ],
    prev: [
      OrderStatus.Draft, OrderStatus.PaymentAwait,
      OrderStatus.Accepted
    ],
    image: 'assets/img/order-status-cooking.svg'
  },
  [OrderStatus.ReadyToShip]: {
    id: 6,
    name: 'Готов к отправке',
    statusName: OrderStatus.ReadyToShip,
    languageName: 'READY_TO_SHIP',
    next: [
      OrderStatus.Shipped,
      OrderStatus.Delivered, OrderStatus.Closed
    ],
    prev: [
      OrderStatus.Draft, OrderStatus.PaymentAwait,
      OrderStatus.Accepted, OrderStatus.Cooking
    ],
    image: 'assets/img/order-status-readytoship.svg'
  },
  [OrderStatus.Shipped]: {
    id: 7,
    name: 'Отправлен',
    statusName: OrderStatus.Shipped,
    languageName: 'SHIPPED',
    next: [
      OrderStatus.Delivered, OrderStatus.Closed
    ],
    prev: [
      OrderStatus.Draft, OrderStatus.PaymentAwait,
      OrderStatus.Accepted, OrderStatus.Cooking,
      OrderStatus.ReadyToShip
    ],
    image: 'assets/img/order-status-readytoship.svg'
  },
  [OrderStatus.Delivered]: {
    id: 8,
    name: 'Доставлен',
    statusName: OrderStatus.Delivered,
    languageName: 'DELIVERED',
    next: [
      OrderStatus.Closed
    ],
    prev: [
      OrderStatus.Draft, OrderStatus.PaymentAwait,
      OrderStatus.Accepted, OrderStatus.Cooking,
      OrderStatus.ReadyToShip, OrderStatus.Shipped
    ],
    image: 'assets/img/order-status-shipped.svg'
  },
  [OrderStatus.Closed]: {
    id: 9,
    name: 'Closed',
    statusName: OrderStatus.Closed,
    languageName: 'CLOSED',
    next: [],
    prev: [
      OrderStatus.Draft, OrderStatus.PaymentAwait,
      OrderStatus.Accepted, OrderStatus.Cooking,
      OrderStatus.ReadyToShip, OrderStatus.Shipped,
      OrderStatus.Delivered
    ],
    image: 'assets/img/order-status-shipped.svg'
  }
};
